import React, { Component } from 'react'
import { profileData } from './fixtures.js'
import MaskedInput from 'react-text-mask'
import DataConstructor from '../DataConstructor/index.jsx'

export default class Password extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="data_settings_profile">
                <DataConstructor
                    id={this.props.id}
                    profileData={profileData}
                    dataProtection={this.props.dataProtection}
                />
            </div>
        )
    }
}
